module.exports = __webpack_public_path__ + "static/media/golden-crown.5934a201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/golden-crown.png
// module id = 665
// module chunks = 0